"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deck = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styled = require("./styled");

var _useDeck2 = require("./use-deck");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Deck = function Deck(_ref) {
  var children = _ref.children;
  var ref = (0, _react.useRef)();

  var _useDeck = (0, _useDeck2.useDeck)(ref),
      previousVisible = _useDeck.previousVisible,
      nextVisible = _useDeck.nextVisible,
      onClickPrevious = _useDeck.onClickPrevious,
      onClickNext = _useDeck.onClickNext,
      onMouseOver = _useDeck.onMouseOver,
      onMouseLeave = _useDeck.onMouseLeave;

  return _react["default"].createElement(_styled.Root, {
    onMouseEnter: onMouseOver,
    onMouseLeave: onMouseLeave
  }, _react["default"].createElement(_styled.ListContainer, {
    ref: ref
  }, _react["default"].Children.map(children, function (child) {
    return _react["default"].createElement(_styled.ListItem, null, child);
  })), _react["default"].createElement(_styled.PreviousButton, {
    onClick: onClickPrevious,
    $visible: previousVisible
  }, "<"), _react["default"].createElement(_styled.NextButton, {
    onClick: onClickNext,
    $visible: nextVisible
  }, ">"));
};

exports.Deck = Deck;
Deck.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]).isRequired
};